var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.78214 0.208915C9.06064 -0.0696043 9.51239 -0.0695365 9.79093 0.208915C10.0695 0.487467 10.0695 0.939151 9.79093 1.2177L6.00773 4.99993L9.79093 8.78313C10.0695 9.06169 10.0695 9.51337 9.79093 9.79192C9.51238 10.0703 9.06062 10.0704 8.78214 9.79192L4.99992 6.00872L1.21769 9.79192C0.939176 10.0705 0.487439 10.0704 0.2089 9.79192C-0.0696335 9.51337 -0.0696335 9.06169 0.2089 8.78313L3.99113 4.99993L0.2089 1.2177C-0.0696318 0.939153 -0.0696286 0.487468 0.2089 0.208915C0.487434 -0.0696382 0.939156 -0.0696382 1.21769 0.208915L4.99992 3.99114L8.78214 0.208915Z",
    fill: "#848484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModal);
export default __webpack_public_path__ + "static/media/close_modal.7acfa7d0bbf93b945db38ed8c6f5e79b.svg";
export { ForwardRef as ReactComponent };